import { addMessageToChat } from '../commons/superconta-chat';

export const TITILAR_KANBAN_MS = 2400;

const RESALTADA = 'kanban-vista-btn--resaltada';
const TITILA = 'kanban-vista-btn--titila';
const RESALTANDO = 'kanban-vista-toggle--resaltando';
const CLICK_KEY = '__titilarKanbanClick';

type TitilarButton = HTMLButtonElement & {
  [CLICK_KEY]?: (event: Event) => void;
};

function findKanbanVistaButton(): TitilarButton | undefined {
  return Array.from(
    document.querySelectorAll<TitilarButton>('.actividades-vista-toggle__btn'),
  ).find(button => button.textContent?.trim() === 'Kanban');
}

function optionsWrap(button: TitilarButton): HTMLElement | null {
  return button.closest('.actividades-vista-toggle__options');
}

function clearResalte(button: TitilarButton): void {
  const handler = button[CLICK_KEY];
  if (handler) {
    button.removeEventListener('click', handler);
    delete button[CLICK_KEY];
  }
  button.classList.remove(RESALTADA, TITILA);
  optionsWrap(button)?.classList.remove(RESALTANDO);
}

export function titilarKanban(nombre: unknown): void {
  const param = String(nombre ?? '').trim();
  if (!param || typeof document === 'undefined') return;
  const button = findKanbanVistaButton();
  if (!button) return;
  clearResalte(button);
  optionsWrap(button)?.classList.add(RESALTANDO);
  button.classList.add(RESALTADA, TITILA);
  const onClick = () => {
    clearResalte(button);
    addMessageToChat(`Ya elegi la vista de Kanban para ver mis tareas en estado ${param}`);
  };
  button[CLICK_KEY] = onClick;
  button.addEventListener('click', onClick);
}

if (typeof window !== 'undefined') {
  window.titilarKanban = titilarKanban;
}
